// @flow
import React from 'react';
import type { Node as ReactNodeType } from 'react';
import { LABEL_NODE_TYPE } from '../constants/ApiTypes';
import './stylesheets/NodeWrapper.scss';

type NodeWrapperProps = {
  x: number,
  y: number,
  height: number,
  width: number,
  rx: number,
  ry: number,
  fill: string,
  selected: boolean,
  selectNode: Function,
  children?: ReactNodeType,
  type: string,
  name: string
};

const findAncestorWithClass = (domNode, className) => {
  let el = domNode;
  while (el && !el.classList.contains(className)) {
    if (el.tagName === 'svg') {
      return null;
    }
    el = el.parentElement;
  }
  return el;
};

const addHighlight = e => {
  const { target } = e;
  const parent = findAncestorWithClass(target, 'node');
  if (parent) {
    parent.classList.add('highlight');
  }
};

const removeHighlight = e => {
  const { target } = e;
  const parent = findAncestorWithClass(target, 'node');
  if (parent) {
    parent.classList.remove('highlight');
  }
};

export const NodeWrapper = (props: NodeWrapperProps) => {
  const {
    x,
    y,
    height,
    width,
    rx,
    ry,
    fill = 'white',
    selected,
    selectNode,
    type,
    name
  } = props;
  const centerX = x - width / 2;
  const isSelectable = type !== LABEL_NODE_TYPE;
  return (
    <g
      key={`node_${name}`}
      className={isSelectable ? 'node selectable' : 'node'}
      transform={`translate(${centerX}, ${y})`}
      onClick={() => !selected && selectNode(name)}
      onMouseEnter={e => {
        if (type !== LABEL_NODE_TYPE) {
          addHighlight(e);
        }
      }}
      onMouseLeave={e => {
        if (isSelectable) {
          removeHighlight(e);
        }
      }}
      id={`node_${name}`}
    >
      <rect
        rx={`${rx}`}
        ry={`${ry}`}
        width={`${width}`}
        height={`${height}`}
        fill="black"
        opacity="0.15"
        className="shadow"
        filter="url(#blur)"
      />
      <rect
        rx={`${rx}`}
        ry={`${ry}`}
        width={`${width}`}
        height={`${height}`}
        fill={`${fill}`}
      />
      {props.children}
    </g>
  );
};

NodeWrapper.defaultProps = {
  children: null
};



// WEBPACK FOOTER //
// ./src/components/NodeWrapper.jsx